/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require('./bootstrap');
require('./components/ua.js');
require('./components/loading.js');
require('./components/main_slider.js');
require('./components/slider.js');
require('./components/scroll_fadein.js');
require('./components/scroll.js');
// require('./components/mov.js');
require('./components/set_vh.js');
require('./components/favorite.js');
